import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import theme from "../../common/theme";
import "@talentbait/shared-components/public/build/app.css";

const PrintUserLayout = ({ children }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default withRouter(PrintUserLayout);
